<agr-summary-card [actions]="actions" [title]="'blightV2.dashboardWidget.title' | translate">
  @if (store.hasBlightPremium()) {
    <div class="content">
      @if (hasBlightAdvices()) {
        <app-disease-dashboard-widget-header
          (selectedDatesChanges)="onSelectedDatesChange($event)"
          [lastCalculatedOnOverride]="store.blightCalculationDate()"
          [maximalDateOverride]="maximalDate()"
          [minimalDateOverride]="store.blightMinAdviceDate()"
          [cropYear]="store.cropYear()"
        />
        <mat-divider />
        <div class="buttons-section">
          @if (showAdviceButton()) {
            <button
              (click)="onViewAdvice()"
              class="w-100"
              color="primary"
              data-test="view-advice-button"
              mat-flat-button
            >
              {{ 'blightV2.dashboardWidget.viewAdvice' | translate }}
            </button>
          }
          <button
            (click)="onAction()"
            [disabled]="isActionButtonDisabled()"
            [matMenuTriggerFor]="actionMenuTop.menu"
            class="action-button"
            color="accent"
            mat-flat-button
          >
            <app-blight-action-menu #actionMenuTop [blightAdvices]="selectedCropFieldAdvices()" />
            <mat-icon>add</mat-icon>
            {{ actionButtonLabel() }}
          </button>
          <app-recalculate-button
            (recalculate)="onRecalculate()"
            [disabled]="isRecalculationDisabled()"
            [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
            [isLoading]="store.isBlightCropFieldsSyncing()"
            [label]="recalculationLabelKey() | translate"
          />
        </div>
        <div class="flex--row spacing--margin-vertical">
          <app-disease-dashboard-widget-table
            (selectedCropFieldsChanged)="onCropFieldSelectionChange($event)"
            [advices]="advicesToShow()"
            [selectedDates]="selectedDates()"
            class="w-100"
          />
        </div>
        <button
          (click)="onAction()"
          [disabled]="isActionButtonDisabled()"
          [matMenuTriggerFor]="actionMenuBottom.menu"
          class="action-button"
          color="accent"
          mat-flat-button
        >
          <app-blight-action-menu #actionMenuBottom [blightAdvices]="selectedCropFieldAdvices()" />
          <mat-icon>add</mat-icon>
          {{ actionButtonLabel() }}
        </button>
        @if (showAdviceButton()) {
          <button
            (click)="onViewAdvice()"
            class="view-advice-button"
            color="primary"
            data-test="view-advice-button"
            mat-flat-button
          >
            {{ 'blightV2.dashboardWidget.viewAdvice' | translate }}
          </button>
        }
      } @else if (isLoading()) {
        <div class="loading-state">
          <app-loading-spinner></app-loading-spinner>
        </div>
      } @else {
        <agr-notification-empty [isEmpty]="true" />
      }
    </div>
  } @else {
    <app-empty-widget [text]="'blightV2.nonPremiumText' | translate" />
  }
</agr-summary-card>
